<!--
Author: Lsc
Date: 2019-08-07
Desc: 预约认申购列表
 -->
<template>
    <div :class="'bizcomp-fund-order bizcomp ' + className">
        <comp-title :title="title" />
        <div class="fund-order">
            <el-row class="fund-filter">
                <el-col :span="24" class="btn-fund">
                    基金类型：
                    <el-radio-group v-model="fundCate" size="mini">
                        <el-radio-button v-for="type in fundType" :key="type.val" :label="type.val">
                            {{ type.text }}
                        </el-radio-button>
                    </el-radio-group>
                </el-col>
                <el-col :span="24" class="btn-fund">
                    基金风险：
                    <el-radio-group v-model="fundRisk" size="mini">
                        <el-radio-button label="">全部</el-radio-button>
                        <el-radio-button
                            v-for="risk in riskList"
                            :key="risk.subitem"
                            :label="risk.subitem"
                        >
                            {{ risk.subitemname }}风险
                        </el-radio-button>
                    </el-radio-group>
                </el-col>
                <el-col :span="24" class="btn-search">
                    查询条件：
                    <span v-for="tag in dynamicTags" :key="tag" style="display: inline-block">
                        <el-tag
                            v-if="tag"
                            closable
                            :disable-transitions="false"
                            v-on:close="handleClose(tag)"
                        >
                            {{ tag }}
                        </el-tag>
                    </span>
                    <el-autocomplete
                        v-model="searchText"
                        popper-class="my-autocomplete"
                        placeholder="请输入查询基金名称或基金代码"
                        class="input-search"
                        size="small"
                        :fetch-suggestions="querySearchAsync"
                    >
                        <template slot-scope="{ item }">
                            <div class="name">
                                {{ item.value }}
                            </div>
                        </template>
                    </el-autocomplete>
                    <el-button
                        class="btn-search-icon"
                        icon="el-icon-search"
                        type="yellow"
                        size="small"
                        v-on:click="searchFund"
                    />
                </el-col>
                <el-col :span="24" class="btn-fund">
                    共有
                    <span class="red">{{ allPage }}</span>
                    条基金&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;排序：
                    <el-row v-model="sortVal" size="small" class="sort-btn">
                        <!--<el-button size="small" :type="sortVal==='sales'?'primary':''" @click="getVal('sales')">按销量<i :class="sort.sales?icond:iconu" aria-hidden="true"></i></el-button>-->
                        <el-button
                            size="small"
                            :type="sortVal === 'grow' ? 'yellow' : ''"
                            v-on:click="getVal('grow')"
                        >
                            按涨跌幅
                            <i aria-hidden="true" :class="sort.grow.up ? icond : iconu" />
                        </el-button>
                        <el-button
                            size="small"
                            :type="sortVal === 'incomeAll' ? 'yellow' : ''"
                            v-on:click="getVal('incomeAll')"
                        >
                            按成立以来收益
                            <i aria-hidden="true" :class="sort.incomeAll.up ? icond : iconu" />
                        </el-button>
                        <el-button
                            size="small"
                            :type="sortVal === 'income' ? 'yellow' : ''"
                            v-on:click="getVal('income')"
                        >
                            按今年以来收益
                            <i aria-hidden="true" :class="sort.income.up ? icond : iconu" />
                        </el-button>
                        <el-button
                            size="small"
                            :type="sortVal === 'risk' ? 'yellow' : ''"
                            v-on:click="getVal('risk')"
                        >
                            按风险
                            <i aria-hidden="true" :class="sort.risk.up ? icond : iconu" />
                        </el-button>
                        <el-select
                            v-show="sortVal ? sort[sortVal].id === '4' : false"
                            v-model="growValue"
                            class="grow-class"
                            size="small"
                            placeholder="请选择区间"
                        >
                            <el-option
                                v-for="item in growArea"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            ></el-option>
                        </el-select>
                    </el-row>
                </el-col>
            </el-row>
            <fund-risk-filter :qryall="qryallfund" v-on:qry-change="qryChange" />
            <order-fund-list
                :fund-info="fund"
                :fund-grow-qry="growValue"
                :all-page="allPage"
                v-on:new-fund="newFund"
                v-on:fund-continue="fundOrderBuy"
            />
        </div>
    </div>
</template>
<script>
import mixin from "@/assets/js/mixin";
import orderFundList from "@/components/fund/orderFundList";
import fundRiskFilter from "@/components/form/fundRiskFilter";
import { getRiskFilter } from "@/util";
export default {
    name: "FundMarket",
    components: {
        orderFundList,
        fundRiskFilter
    },
    mixins: [mixin],
    data() {
        return {
            conf: {}, // 初始化配置文件内容
            fundCate: "2", // 基金类型
            fundRisk: "", // 基金风险
            searchText: "", // 搜索文本内容
            sortVal: "", // 排序字段
            lastSortVal: "", // 上次排序字段
            fund: [], // 基金信息
            dynamicTags: [], // 筛选条件
            queryFind: null, // 定时器
            qryallfund: getRiskFilter(), // 适当性过滤字段
            allPage: "0", // 所有数据条数
            pagecount: "", // 分页条数
            pageoffset: "0", // 起始页
            riskList: [],
            url: "", // 当前页面路由命名
            fundType: [
                { val: "", text: "全部" },
                { val: "2", text: "货币型" },
                { val: "3", text: "混合型" },
                /* { val: "0", text: "股票型" }, */
                { val: "1", text: "债券型" },
                { val: "5", text: "指数型" }
                /* { val: "4", text: "专户型" },
                { val: "6", text: "QDII基金" } */
            ],
            iconu: "el-icon-upload2",
            icond: "el-icon-download",
            sort: {
                incomeAll: {
                    id: "2",
                    up: true
                },
                grow: {
                    id: "4",
                    up: true
                },
                income: {
                    id: "3",
                    up: true
                },
                risk: {
                    id: "8",
                    up: false
                }
            },
            growArea: [
                {
                    value: "4",
                    label: "日涨跌幅"
                },
                {
                    value: "9",
                    label: "近一周涨跌幅"
                },
                {
                    value: "5",
                    label: "近一月涨跌幅"
                },
                {
                    value: "6",
                    label: "近三月涨跌幅"
                },
                {
                    value: "7",
                    label: "近六月涨跌幅"
                },
                {
                    value: "10",
                    label: "近一年涨跌幅"
                },
                {
                    value: "11",
                    label: "近两年涨跌幅"
                },
                {
                    value: "12",
                    label: "近三年涨跌幅"
                },
                {
                    value: "13",
                    label: "近五年涨跌幅"
                }
            ],
            growValue: ""
        };
    },
    watch: {
        // 监测选项变化
        fundCate(val, from) {
            if (!val) {
                const _x = this.fundType.find((risk) => {
                    return risk.val === from;
                });
                this.dynamicTags.splice(this.dynamicTags.indexOf(_x.text), 1);
            } else {
                const _x = this.fundType.find((risk) => {
                    return risk.val === val;
                });
                this.$set(this.dynamicTags, 0, _x.text);
            }
            this.pageoffset = "0";
            this.doAction();
        },
        fundRisk(val, from) {
            if (!val) {
                const _x = this.riskList.find((risk) => {
                    return risk.subitem === from;
                });
                this.dynamicTags.splice(this.dynamicTags.indexOf(_x.subitemname), 1);
            } else {
                const _x = this.riskList.find((risk) => {
                    return risk.subitem === val;
                });
                this.$set(this.dynamicTags, 1, _x.subitemname + "风险");
            }
            this.pageoffset = "0";
            this.doAction();
        },
        growValue(val) {
            if (val) {
                this.doAction();
            }
        },
        sortVal(val) {
            if (this.sort[val].id !== "4") {
                this.growValue = "";
            }
        }
    },
    created() {
        this.url = this.$route.name;
        this.pagecount = this.$util.getConfig().const.PAGE_SIZE;
        this.riskList = this.$cache.getDict("110143");
        this.doAction();
    },
    mounted() {
        this.getVal("grow");
    },
    methods: {
        // 获取排序数据
        getVal(val) {
            this.sortVal = val;
            if (this.sortVal === this.lastSortVal) {
                this.sort[val].up = !this.sort[val].up;
            } else {
                this.lastSortVal = this.sortVal;
            }
            this.doAction();
        },
        // 处理基金适当性信息
        fundOrderBuy(way, val) {
            this.$util.fundRiskCheck(this, val, (res) => {
                if (res) {
                    const _x = Object.assign({}, res, { way: way, proto: "bookingbuy" });
                    this.$router.push({ name: "orderbuyfund", query: _x });
                }
            });
        },
        // 搜索基金
        searchFund() {
            this.doAction(this.searchText);
        },
        // 改变风险过滤规则
        qryChange(val) {
            this.qryallfund = val;
            this.pageoffset = "0";
            this.doAction();
        },
        // 获取下拉列表数据
        querySearchAsync(queryString, cb) {
            this.doAction(queryString, (res) => {
                let _cbArr = [];
                res.forEach((item, index) => {
                    let _x = {};
                    _x.value = item.fundname + "(" + item.fundcode + ")";
                    _x.id = item.fundcode;
                    _x.index = index;
                    _cbArr.push(_x);
                });
                cb(_cbArr);
            });
        },
        // 获取新一页数据
        newFund(val) {
            this.pageoffset = val - 1;
            this.doAction();
        },
        // 获取基金信息
        getFund(val, cb) {
            const _this = this;
            const _x = {
                fundtype: this.fundCate,
                risklevel: this.fundRisk,
                ordertype: this.growValue
                    ? this.growValue
                    : this.sortVal
                    ? this.sort[this.sortVal].id
                    : "",
                isasc: this.sortVal ? (this.sort[this.sortVal].up ? "0" : "1") : "",
                qryallfund: this.qryallfund,
                flag: "7",
                keyword: val || this.searchText,
                pagecount: cb ? "1000" : this.pagecount,
                pageoffset: ((val ? "0" : this.pageoffset) * this.pagecount).toString(),
                qrysmflag: "1"
            };
            this.$util.request("trade/fund/list", _x, "GET", false).then((res) => {
                if (res.data) {
                    if (!cb) {
                        this.fund = res.data[0];
                        this.qryallfund = res.data[1][0].qryallfund;
                        const info = _this.$cache.getUser();
                        info.qryallfund = _this.qryallfund;
                        _this.$store.dispatch("setInfo", info);
                        this.allPage = res.alllength;
                    } else {
                        cb.call(this, res.data[0]);
                    }
                }
            });
        },
        // 对基金频繁查询请求做处理
        doAction(val, cb) {
            const _this = this;
            if (cb) {
                val = this.$util.filterCode(val);
                this.searchText = val;
                if (val.length < 1) {
                    cb.call(this, []);
                    return false;
                }
            }
            clearTimeout(this.queryFind);
            this.queryFind = setTimeout(function () {
                _this.getFund(val, cb);
            }, 100);
        },
        // 搜索选项关闭处理
        handleClose(val) {
            if (val.toString().indexOf("风险") > -1) {
                this.fundRisk = "";
            } else {
                this.fundCate = "";
            }
        }
    }
};
</script>
